

































































































import { Component, Watch, Prop, Vue } from "vue-property-decorator";
import { ILocale } from "@/@types/locale";
import { ICoast } from "@/@types/_shared/coast";
import { IExcursionCoast } from "@/@types/excursions/excursions";
import { ICurrency } from "@/@types/currency";
import { mapGetters } from "vuex";

import ButtonLocales from "@/components/buttons/button-locales.vue";

@Component({
  components: { ButtonLocales },
  computed: {
    ...mapGetters({
      currencys: "getCurensy",
    }),
  },
})
export default class ExcursionCoastForm extends Vue {
  @Prop({ type: Array, default: () => [] }) coasts!: Array<IExcursionCoast>;
  currencys!: Array<ICurrency>;
  activeLocale = this.$store.getters.getLanguages[0];

  name = "";
  names: ILocale = {};
  coastElement: ICoast = {
    currency: "",
    value: 0,
  };
  coastCoasts: ICoast[] = [];

  @Watch("name")
  makeName(): void {
    this.names[this.activeLocale] = this.name;
  }

  @Watch("activeLocale")
  placeName(): void {
    if (this.names)
      this.name = this.names[this.activeLocale]
        ? this.names[this.activeLocale]
        : "";
    else this.name = "";
  }

  @Watch("coastElement", { deep: true })
  changeCoast(): void {
    if (!this.coastElement.currency || !this.coastElement.value) return;
    for (const coast of this.coastCoasts) {
      if (this.coastElement.currency == coast.currency) {
        coast.currency = this.coastElement.currency;
        coast.value = this.coastElement.value;
        this.coastElement = {
          value: 0,
          currency: "",
        };
        return;
      }
    }
    this.coastCoasts.push(this.coastElement);
    this.saweCoast();
    this.coastElement = {
      value: 0,
      currency: "",
    };
  }

  saweCoast(): void {
    for (let i = 0; i < this.coastCoasts.length; i++) {
      if (!this.coastCoasts[i].currency || !this.coastCoasts[i].value)
        this.coastCoasts.splice(i, 1);
    }
    this.$emit("changeCoast", {
      name: this.names,
      coast: this.coastCoasts,
    });

    this.names = {};
    this.name = "";
    this.coastCoasts = [];
    this.coastElement = {
      currency: "",
      value: 0,
    };
  }
}
